(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["industrialline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('industrial-lines-slider')) {
    class IndustrialLinesSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.track = this.querySelector('[data-track]');
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.dotsWrap = this.querySelector('[data-dots]');
        this.loop = this.dataset.loop === 'true';

        if (!this.track || !this.cards.length) return;

        this.onScroll = this.update.bind(this);
        this.onResize = this.refresh.bind(this);
        this.onPrev = () => this.move(-1);
        this.onNext = () => this.move(1);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prevButton?.addEventListener('click', this.onPrev);
        this.nextButton?.addEventListener('click', this.onNext);

        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.track);

        this.refresh();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.prevButton?.removeEventListener('click', this.onPrev);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.resizeObserver?.disconnect();
      }

      getGap() {
        const styles = getComputedStyle(this.track);
        return parseFloat(styles.columnGap || styles.gap || 0);
      }

      getStep() {
        if (!this.cards[0]) return 0;
        return this.cards[0].getBoundingClientRect().width + this.getGap();
      }

      getVisibleCount() {
        const step = this.getStep();
        if (!step) return 1;
        return Math.max(1, Math.round((this.track.clientWidth + this.getGap()) / step));
      }

      getMaxIndex() {
        return Math.max(0, this.cards.length - this.getVisibleCount());
      }

      getCurrentIndex() {
        const step = this.getStep();
        if (!step) return 0;
        return Math.min(this.getMaxIndex(), Math.max(0, Math.round(this.track.scrollLeft / step)));
      }

      scrollToIndex(index) {
        const safeIndex = Math.min(this.getMaxIndex(), Math.max(0, index));
        const step = this.getStep();
        this.track.scrollTo({ left: step * safeIndex, behavior: 'smooth' });
      }

      move(direction) {
        const current = this.getCurrentIndex();
        const max = this.getMaxIndex();
        let next = current + direction;

        if (this.loop) {
          if (next > max) next = 0;
          if (next < 0) next = max;
        }

        this.scrollToIndex(next);
      }

      buildDots() {
        if (!this.dotsWrap) return;

        const count = this.getMaxIndex() + 1;
        if (this.dotCount === count) return;
        this.dotCount = count;
        this.dotsWrap.innerHTML = '';

        for (let index = 0; index < count; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'il-dot';
          dot.setAttribute('aria-label', `Go to item ${index + 1}`);
          dot.addEventListener('click', () => this.scrollToIndex(index));
          this.dotsWrap.appendChild(dot);
        }
      }

      refresh() {
        const scrollable = this.track.scrollWidth > this.track.clientWidth + 2;
        this.dataset.scrollable = scrollable ? 'true' : 'false';
        this.buildDots();
        this.update();
      }

      update() {
        const current = this.getCurrentIndex();
        const max = this.getMaxIndex();
        const dots = this.dotsWrap ? Array.from(this.dotsWrap.children) : [];

        dots.forEach((dot, index) => {
          const active = index === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        if (this.prevButton) this.prevButton.disabled = !this.loop && current <= 0;
        if (this.nextButton) this.nextButton.disabled = !this.loop && current >= max;
      }
    }

    customElements.define('industrial-lines-slider', IndustrialLinesSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
